import React from 'react'
import EmptyStateImg from '../assets/images/empty_state.svg'
import { Typography } from '@mui/material';

const emptyState = ({ message, messageFontSize, subMessage, height, width, imageSrc }) => {
  return (
    <div className='flex flex-col items-center justify-center w-full' style={{ height: height ?? "60vh" }}>
      <img src={imageSrc ?? EmptyStateImg} className='img img-fluid' alt='' width={width ?? 300} />
      {message ? <Typography fontWeight={700} fontSize={messageFontSize ??14} className='text-blue-111 mt-6'>{message}</Typography> :
        // <h5 className='fs-header theme-dark-color mt-16'>{"No Data Found"}</h5>
        null
      }
      {subMessage ? <Typography fontWeight={400} fontSize={12} className='text-gray-6B mt-1'>{subMessage}</Typography> :
        // <h5 className='fs-header theme-dark-color mt-16'>{"No Data Found"}</h5>
        null
      }
    </div>
  )
}
export default emptyState;
